
import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
  })
  export class CryptoService {
    constructor(){}

    hiddenKey = (() => {
      const parts = ['siv', '54321', '12345', 'vis'];
      return parts.reverse().join('');
    })();
    encrypt(data:string){
        // const hiddenKey = (() => {
        //   const parts = ['siv', '54321', '12345', 'vis'];
        //   return parts.reverse().join('');
        // })();
        const ivArray = new Array(16).fill(97);
        const hiddenIV = ivArray.map(c => String.fromCharCode(c)).join('');
        const k = CryptoJS.enc.Utf8.parse(this.hiddenKey);
        const p = CryptoJS.AES.encrypt(data,k,{
            iv: hiddenIV,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.ZeroPadding
        });
        return CryptoJS.enc.Base64.stringify(p.ciphertext);
    }
    decrypt(encryptedData: string) {
      const ivArray = new Array(16).fill(97);
      const hiddenIV = ivArray.map(c => String.fromCharCode(c)).join('');
      const k = CryptoJS.enc.Utf8.parse(this.hiddenKey);
      const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: ciphertext },
        k,
        {
          iv: hiddenIV,
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.ZeroPadding
        }
      );
      return CryptoJS.enc.Utf8.stringify(decrypted);
    }
    /** 風險值專用方法 */
    riskAssEncrypt(): string {
      const hiddenKey = (() => {
        const parts = ["87705256", "Hpa02", "asiavision:"];
        return parts.reverse().join('');
      })();
      const binaryString = new TextEncoder().encode(hiddenKey);
      let base64String = '';
      for (let i = 0; i < binaryString.length; i++) {
        base64String += String.fromCharCode(binaryString[i]);
      }

      return btoa(base64String);
    }
    /** 高雄市TOCC，呼叫翰鼎API，需產生驗證碼。 */
    async generateHMAC(code: string, data: string)
    {
      var SecretKey = 'D2x9Mn5Q8V4rT1Y7Lk6Gh3S0Wj4Fp9C7';
      var result = '';
      try
      {
        const secretAccessKey = SecretKey;
        const input = code + (data ?? '');
        const secretKey = new TextEncoder().encode(secretAccessKey);
        const combineData = new TextEncoder().encode(input);
        // await crypto.subtle.importKey(
        //   'raw',
        //   secretKey,
        //   { name: 'HMAC', hash: { name: 'SHA-256' } },
        //   false,
        //   ['sign']
        // ).then(async (cryptoKey) => {
        //   await crypto.subtle.sign('HMAC', cryptoKey, combineData).then((hash) => {
        //     const uint8Array = new Uint8Array(hash);
        //     const hashString = String.fromCharCode.apply(null, uint8Array);
        //     result = btoa(hashString);
        //   });
        // });
        const cryptoKey = await crypto.subtle.importKey(
          'raw',
          secretKey,
          { name: 'HMAC', hash: { name: 'SHA-256' } },
          false,
          ['sign']
        );
        const hash = await crypto.subtle.sign('HMAC', cryptoKey, combineData);
        const uint8Array = new Uint8Array(hash);
        const hashString = String.fromCharCode.apply(null, uint8Array);
        result = btoa(hashString);
      }
      catch (ex)
      {
        result = '';
      }
      return result;
    }

    /** NIIS Api CheckCode */
    generateCheckCode(nhiCode: string, hisKeyId: string) {
      //return CryptoJS.enc.Base64.stringify(nhiCode + ':' + hisKeyId);
      const combinedString = `${nhiCode.trim()}:${hisKeyId.trim()}`;
      const wordArray = CryptoJS.enc.Utf8.parse(combinedString);
      return CryptoJS.enc.Base64.stringify(wordArray);
    }
  }
